<template>
    <div style="clear: both;" class="animate__animated animate__fadeIn">
        <div class="person_box">
            <div class="person">
                <div class="safety_title">
                    <div>安全巡检性质</div>
                    <div class="add_btn" @click="fnAdd('添加巡检性质参数', 0)">添加</div>
                </div>
                <div class="cont_list">
                    <div class="list_title">
                        <div class="title_item">参数设置</div>
                        <div class="title_item">操作</div>
                    </div>
                    <div class="list_boxes">
                        <div class="list_box">
                            <div v-if="xzlist">
                                <div class="box_line" v-for="(item, index) in xzlist" :key="index">
                                    <div class="list_item">
                                        <div class="line_input2">
                                            <div class="input_box">{{ item.name }}</div>
                                        </div>
                                    </div>
                                    <div class="list_item">
                                        <div v-if="item.project_id != 0">
                                            <div class="search-btn" @click="handleEdit(index, item, 0, '编辑巡检性质参数')"><span>编辑</span></div>
                                            <div class="search-btn red" @click="handleDelete(index, item)"><span>删除</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="person_box">
            <div class="person">
                <!-- <div style="height:40px;clear:both;">
					<div class="bt">安全巡检类别</div>
					<div style="margin-top: -2.6%;" class="add_btn yellow" @click="fnAdd('添加巡检类别参数', 1)">添加</div>
				</div> -->
                <div class="safety_title">
                    <div>安全巡检类别</div>
                    <div class="add_btn" @click="fnAdd('添加巡检性质参数', 1)">添加</div>
                </div>
                <div class="cont_list">
                    <div class="list_title">
                        <div class="title_item">参数设置</div>
                        <div class="title_item">操作</div>
                    </div>
                    <div class="list_boxes">
                        <div class="list_box">
                            <div v-if="lblist">
                                <div class="box_line" v-for="(item, index) in lblist" :key="index">
                                    <div class="list_item">
                                        <div class="line_input2">
                                            <div class="input_box">{{ item.name }}</div>
                                        </div>
                                    </div>
                                    <div class="list_item">
                                        <div v-if="item.project_id != 0">
                                            <div class="search-btn" @click="handleEdit(index, item, 0, '编辑巡检性质参数')"><span>编辑</span></div>
                                            <div class="search-btn red" @click="handleDelete(index, item)"><span>删除</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog_addEdit animate__animated animate__fadeIn" v-if="dialogVisible">
            <el-dialog :modal="false" :title="title" :visible.sync="dialogVisible" center style="text-align: center">
                <div style="text-align: center">
                    <el-input style="width: 80%" type="textarea" :row="3" class="input" placeholder="请输入内容" v-model="editparam" size="large"></el-input>
                </div>
                <div slot="footer" class="dialog-footer">
                    <div class="btn_line">
                        <div class="search-btn red" @click="dialogVisible = false"><span>取消</span></div>
                        <div class="search-btn" @click="fnEditReq"><span>确定</span></div>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import sha1 from 'js-sha1';
import APP from '@/utils/base';
import request from '@/utils/request';
import { Loading } from 'element-ui';
import { fnCookie } from '@/utils/localStorage';
import { getUserInfo } from '@/utils/auth';

export default {
    props: ['editInfo'],
    data() {
        return {
            dialogVisible: false,
            lblist: [],
            xzlist: [],
            showDate: true,
            dateStart: '',
            editparam: '', //编辑参数
            title: '',

            editid: 0,
            type: 0 //0巡检性质 ,1巡检类别
        };
    },
    created() {
        this.fnGetData();
    },
    methods: {
        //添加
        fnAdd(tit, type) {
            this.editparam = '';
            this.dialogVisible = true;
            this.title = tit;
            this.type = type;
        },
        //添加请求
        fnEditReq() {
            this.dialogVisible = false;
            request({
                url: '/qualitySafe/handleParamSafe',
                method: 'POST',
                data: {
                    type: this.type,
                    id: this.editid,
                    type: this.type,
                    name: this.editparam
                }
            })
                .then(res => {
                    this.$message.success(res.data);
                    this.fnGetData();
                })
                .catch(err => {
                    this.$message.error(err.data);
                });
        },
        //修改参数
        handleEdit(a, e, t, ti) {
            this.editid = e.id;
            this.editparam = e.name;
            this.type = t;
            this.title = ti;
            this.dialogVisible = true;
        },
        //删除参数
        handleDelete(a, e) {
            let pid = e.id;
            request({
                url: '/qualitySafe/deleteParamSafe',
                method: 'POST',
                data: {
                    id: pid
                }
            })
                .then(res => {
                    this.$message.success(res.data);
                    this.fnGetData();
                })
                .catch(err => {
                    this.$message.error(err.data);
                });
        },
        fnGetData() {
            request({
                url: '/qualitySafe/getParamSafe',
                method: 'GET'
            })
                .then(res => {
                    this.lblist = res.data.lb;
                    this.xzlist = res.data.xz;
                })
                .catch(err => {
                    this.$message.error(err.data);
                });
        }
    }
};
</script>
<style lang="scss" scoped>
@import '@/styles/mixin.scss';
.person_box {
    float: left;
    width: 900px;
    height: 858px;
    margin: 0 30px;
    position: relative;
    overflow: hidden;
    .person {
        position: absolute;
        left: 0;
        right: -20px;
        top: 0;
        bottom: 0;
        overflow-x: hidden;
        overflow-y: auto;
    }
}
.safety_title {
    width: 900px;
    height: 40px;
    margin-top: 29px;
    font-size: 20px;
    font-weight: bold;
    position: relative;
    @include flex-box(center, center);
    .add_btn {
        position: absolute;
        right: 20px;
        width: 69px;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        color: #ffffff;
        border: none;
        cursor: pointer;
        background: url(../../../assets/img/btn_bg_osm.png) no-repeat;
        background-size: 100% 100%;
        @include flex-box(center, center);
        span {
            margin-top: -2px;
        }
    }
}
.cont_list {
    margin-top: 19px;
    width: 900px;
    height: 756px;
    border-radius: 10px;
    background-color: rgba(29, 68, 149, 0.1);
    .list_title {
        width: 900px;
        height: 48px;
        background: url(../../../assets/img/per_list_bg.png) no-repeat;
        background-size: 100% 100%;
        @include flex-box(flex-start, center);
        .title_item {
            width: 400px;
            height: 48px;
            @include flex-box(center, center);
            &:nth-child(1) {
                margin-right: 2px;
                margin-left: 40px;
            }
            &:nth-child(2) {
                width: 400px;
                margin: 0 2px;
            }
        }
    }
    .list_boxes {
        width: 844px;
        height: 708px;
        position: relative;
        overflow: hidden;
        .list_box {
            position: absolute;
            left: 0;
            right: -25px;
            top: 0;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: auto;
            .box_line {
                width: 844px;
                height: 70px;
                margin: 7px 0 0 40px;
                font-size: 16px;
                color: #ffffff;
                border-bottom: 1px dashed #1d4495;
                @include flex-box(flex-start, center);
                .list_item {
                    width: 400px;
                    height: 70px;
                    text-align: center;
                    @include flex-box(center, center);
                    &:nth-child(1) {
                        margin-right: 2px;
                    }
                    &:nth-child(2) {
                        width: 400px;
                        margin: 0 2px;
                    }
                    div {
                        @include flex-box(center, center);
                    }
                }
            }
        }
    }
}
.box_line {
    >>> .el-input__inner {
        width: 211px;
        height: 30px;
        border-radius: 2px;
        border: none;
        color: rgba(77, 180, 244, 0.7);
        background: transparent;
        &::-webkit-input-placeholder {
            color: rgba(77, 180, 244, 0.7);
        }
        &::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: rgba(77, 180, 244, 0.7);
        }
        &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: rgba(77, 180, 244, 0.7);
        }
        &:-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: rgba(77, 180, 244, 0.7);
        }
    }
    >>> .el-select__caret {
        color: rgba(77, 180, 244, 0.7);
    }
    >>> .el-select-dropdown {
        background-color: rgba(77, 180, 244, 0.2);
        border: 1px solid rgba(77, 180, 244, 1);
    }
    >>> .popper__arrow {
        border-bottom-color: rgba(77, 180, 244, 1) !important;
    }
    >>> .el-select-dropdown__item {
        color: rgba(77, 180, 244, 0.7);
    }
    >>> .el-select-dropdown__item:hover {
        color: #409eff;
    }
    >>> .el-select-dropdown__item.hover {
        color: #409eff;
    }
    >>> .el-input__icon {
        color: rgba(77, 180, 244, 0.7);
    }
    >>> .el-range-input {
        background: transparent;
        &::-webkit-input-placeholder {
            color: rgba(77, 180, 244, 0.7);
        }
        &::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: rgba(77, 180, 244, 0.7);
        }
        &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: rgba(77, 180, 244, 0.7);
        }
        &:-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: rgba(77, 180, 244, 0.7);
        }
    }
    >>> .el-range-separator {
        color: rgba(77, 180, 244, 0.7);
    }
}
.line_input2 {
    min-width: 340px;
    height: 30px;
    margin-right: 10px;
    border-top-right-radius: 1px;
    border-bottom-right-radius: 1px;
    background-color: rgba(49, 88, 128, 0.4);
    @include flex-box(flex-start, center);
    .input_title {
        width: 69px;
        height: 30px;
        font-size: 14px;
        color: #9bf9fc;
        border-radius: 2px;
        background-color: rgba(155, 249, 252, 0.1);
        @include flex-box(center, center);
    }
    .input_box {
        width: 211px;
        height: 30px;
        line-height: 30px;
        color: rgba(77, 180, 244, 0.7);
        font-size: 12px;
        border-radius: 2px;
        outline: none;
        background: transparent;
        border: none;
        &::-webkit-input-placeholder {
            color: rgba(77, 180, 244, 0.7);
        }
        &::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: rgba(77, 180, 244, 0.7);
        }
        &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: rgba(77, 180, 244, 0.7);
        }
        &:-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: rgba(77, 180, 244, 0.7);
        }
    }
    .select_box {
        width: 211px;
        height: 30px;
        border-radius: 2px;
    }
}
.dialog_addEdit {
    >>> .el-dialog {
        margin-top: 25vh !important;
    }
    >>> .el-textarea__inner {
        max-height: 325px;
    }
}
.dialog_addEdit {
    .btn_line {
        @include flex-box(center, center);
    }
    >>> .el-dialog {
        width: 800px;
        height: 500px;
        margin-top: 20vh !important;
        background-color: rgba(9, 17, 32, 1);
        border: 1px solid rgba(58, 116, 221, 1);
    }
    >>> .el-form-item__label {
        color: #4db4f4;
    }
    >>> .el-dialog__title {
        color: #4db4f4;
    }
    >>> .el-dialog__close {
        color: #4db4f4;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/SafetyInspectionSet/safeInspectionSetDefault/index.vue